import {DefaultTimelineMetadata} from "../../../../../util/types";
import {findMetadata, isDateAfter, isDateBefore, isDateSame, isDateSameOrAfter} from "../../../../../util/helpers";
import Card from "./Card";
import {formatDateText} from "../../../../../util/formatter";
import IconRocket from "../../../../icons/IconRocket.tsx";

export const TechnicianOnlineCard = ({metadata}: { metadata: DefaultTimelineMetadata[] }) => {
    const technician_visit_date = findMetadata('technician_visit_date', metadata);
    const active_date = findMetadata('product_instance_status_active_date', metadata) ?? technician_visit_date;
    const is_online: boolean = isDateSameOrAfter(active_date);
    const technician_interval = findMetadata('technician_interval', metadata);

    const getTitle = (active_date: string, technician_interval: string) : string => {
        if (isDateBefore(active_date)) {
            return `Teknikerbesøg mellem kl. ${technician_interval}`;
        }
        if (isDateSame(active_date)) {
            return `Teknikerbesøg i dag mellem kl. ${technician_interval}`;
        }
        if (isDateAfter(active_date)) {
            return 'Teknikerbesøg';
        }
        return 'Teknikerbesøg og dit internet er klar';
    }

    return <Card
        done={is_online}
        position={'end'}
        title={getTitle(active_date, technician_interval)}
        icon={IconRocket}
    >
        {active_date ?
            <>
                {isDateBefore(active_date) &&
                    <>
                        <p>En myndig person skal være hjemme under besøget.</p>
                        <p className={'date'}>{formatDateText(active_date)}</p>
                    </>
                }
                {isDateSame(active_date) &&
                    <>
                        <p>En myndig person skal være hjemme under besøget.</p>
                        <p className={'date'}>{formatDateText(active_date)}</p>
                    </>
                }
                {isDateAfter(active_date) &&
                    <>
                        <p>Dit internet var klar til brug</p>
                        <p className={'date'}>{formatDateText(active_date)}</p>
                    </>
                }
            </>
            :
            <p className={'date'}>
                Vi afventer datoen for besøget.
            </p>
        }
    </Card>
}
